import { Control, FieldPath, FieldValues } from 'react-hook-form'
import { z } from 'zod'

import TimeInput from '../timeInput'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '.'

interface FormTimeInputProps<T extends FieldValues> {
    control: Control<T>
    name: FieldPath<T>
    label?: React.ReactNode
    className?: string
}

export const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/
export const timeSchema = z.string().regex(timeRegex)

export default function FormTimeInput<T extends FieldValues>({
    control,
    name,
    label,
    className,
}: FormTimeInputProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        <TimeInput className={'w-32'} {...field} />
                    </FormControl>

                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
